<template>
  <!-- valeur par défaut d'un réglage modifié, avec un bouton pour la rétablir (Step 4, 19/10/2026) -->
  <span v-if="modifie" class="defaut-champ" :title="'Valeur par défaut : ' + texte">
    défaut : {{ texte }}
    <button type="button" class="defaut-champ__retablir" :aria-label="'Rétablir la valeur par défaut (' + texte + ')'"
      title="Rétablir la valeur par défaut" @click="$emit('retablir')">↺</button>
  </span>
</template>

<script>
/** Vrai si la valeur saisie diffère de la valeur par défaut (nombres comparés en valeur, « 3.50 » = 3,5). */
export function estModifie(valeur, defaut) {
  if (typeof defaut === 'boolean') return !!valeur !== defaut
  var vide = function (v) { return v === null || v === undefined || v === '' }
  if (vide(valeur) || vide(defaut)) return vide(valeur) !== vide(defaut)
  var a = Number(valeur), b = Number(defaut)
  if (isNaN(a) || isNaN(b)) return String(valeur) !== String(defaut)
  return Math.abs(a - b) > 1e-9
}

export default {
  name: 'DefautChamp',
  props: {
    valeur: { default: null },
    defaut: { default: null },
    unite: { type: String, default: '' },
    decimales: { type: Number, default: null },
  },
  computed: {
    modifie() { return estModifie(this.valeur, this.defaut) },
    texte() {
      var d = this.defaut
      if (typeof d === 'boolean') return d ? 'activé' : 'désactivé'
      if (d === null || d === undefined || d === '') return 'vide'
      var n = Number(d)
      var t = this.decimales != null
        ? n.toLocaleString('fr-FR', { minimumFractionDigits: this.decimales, maximumFractionDigits: this.decimales })
        : n.toLocaleString('fr-FR', { maximumFractionDigits: 3 })
      return t.replace(/ | /g, ' ') + (this.unite ? ' ' + this.unite : '')
    },
  },
}
</script>

<style scoped>
.defaut-champ { display: inline-flex; align-items: center; gap: 4px; margin-top: 3px; font-size: 12px; color: #8a5a00; white-space: nowrap; }
.defaut-champ__retablir { border: 1px solid #e0c27a; background: #fff8e6; color: #8a5a00; border-radius: 4px; padding: 0 5px; line-height: 18px; font-size: 13px; cursor: pointer; }
.defaut-champ__retablir:hover { background: #ffecb8; }
</style>
